import type { JSX } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Home } from "@/pages/home";
import { Product } from "@/pages/product";
import { PrimeReactProvider } from "primereact/api";

import { ChargeC1, Climate1, Touch1, Ultra1, PowerC1, LEDW1 } from "@/data/products";
import { AboutUs } from "./pages/about-us";
import { ContactUs } from "./pages/contact-us";
import { Footer } from "./components/Footer";

function Layout(element: JSX.Element): JSX.Element {
  return (
    <div className="h-full w-full text-gray-600">
      <Navbar />
      { element }
      <Footer />
    </div>
  )
}

export function App(): JSX.Element {
  return (
    <PrimeReactProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={Layout(<Home />)} />
          <Route path="/touch1" element={Layout(<Product details={Touch1} />)} />
          <Route path="/climate1" element={Layout(<Product details={Climate1} />)} />
          <Route path="/ultra1" element={Layout(<Product details={Ultra1} />)} />
          <Route path="/charge-c1" element={Layout(<Product details={ChargeC1} />)} />
          <Route path="/power-c1" element={Layout(<Product details={PowerC1} />)} />
          <Route path="/led-w1" element={Layout(<Product details={LEDW1} />)} />
          <Route path="/contact-us" element={Layout(<ContactUs/>)} />
          <Route path="/about-us" element={Layout(<AboutUs />)} />
        </Routes>
      </BrowserRouter>
    </PrimeReactProvider>
  )
}

export default App;
